import React from 'react';
import ProductCard from './ProductCard';
import { Package } from 'lucide-react';

const SkeletonCard = () => (
  <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 animate-pulse">
    <div className="bg-gray-200" style={{ aspectRatio: '4/5' }} />
    <div className="p-3.5 space-y-2">
      <div className="h-3 bg-gray-200 rounded w-1/3" />
      <div className="h-4 bg-gray-200 rounded w-4/5" />
      <div className="h-4 bg-gray-200 rounded w-3/5" />
      <div className="h-5 bg-gray-200 rounded w-1/2 mt-2" />
    </div>
  </div>
);

const ProductGrid = ({ products, loading, skeletonCount = 8, listId = null, listName = '', startIndex = 0 }) => {
  if (loading && (!products || products.length === 0)) {
    return (
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <SkeletonCard key={i} />
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-4">
          <Package className="w-10 h-10 text-gray-300" />
        </div>
        <h3 className="text-base font-semibold text-gray-900 mb-1">No products found</h3>
        <p className="text-sm text-gray-500 max-w-xs">
          Try adjusting your filters or search terms to find what you're looking for.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4">
      {products.map((product, i) => (
        <ProductCard
          key={product.id}
          product={product}
          listId={listId}
          listName={listName}
          index={startIndex + i}
        />
      ))}
    </div>
  );
};

export default ProductGrid;
